import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../lib/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Token verifikasi tidak ditemukan.');
      return;
    }

    const verify = async () => {
      try {
        const res = await api.get(`/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage(res.data.message);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Gagal memverifikasi email.');
      }
    };

    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-12 md:py-20 text-center">
        <div className="border-2 border-foreground bg-white shadow-brutal-lg p-10">
          {status === 'verifying' && (
            <>
              <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
              <h1 className="font-display text-2xl font-bold mb-2">Memverifikasi...</h1>
              <p className="text-muted-foreground">Tunggu sebentar ya, akunmu sedang kami aktifkan.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6 border-2 border-foreground">
                <span className="text-4xl">✅</span>
              </div>
              <h1 className="font-display text-3xl font-bold mb-4">Berhasil!</h1>
              <p className="text-foreground/70 leading-relaxed mb-8">
                {message} Sekarang kamu sudah bisa login dan mulai berkarya.
              </p>
              <Link
                to="/login"
                className="w-full inline-block border-2 border-foreground bg-primary text-white px-4 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
              >
                Login Sekarang
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 border-2 border-foreground">
                <span className="text-4xl">❌</span>
              </div>
              <h1 className="font-display text-3xl font-bold mb-4">Waduh!</h1>
              <p className="text-foreground/70 leading-relaxed mb-8">
                {message}
              </p>
              <Link
                to="/register"
                className="w-full inline-block border-2 border-foreground bg-white text-foreground px-4 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] transition-all mb-4"
              >
                Coba Daftar Lagi
              </Link>
              <Link to="/login" className="block text-sm font-bold underline underline-offset-4">
                Kembali ke Login
              </Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
